/**
 * Remplace les attributs des liens externes contenus dans le html pour permettre leur ouverture dans un nouvel onglet
 * @param htmlContent string
 */
export const replaceExternalLinksInHtmlContent = (htmlContent: string) => {
  const env = process.env.NEXT_PUBLIC_APP_TIER;
  const baseUrlEnvPrefix = env === 'dev' || env === 'staging' ? `${env}.` : '';

  const externalLinkRegexp = new RegExp(
    `(<a href="https://(?!www.${baseUrlEnvPrefix}mon-marche.fr)[^>]+)(>)`,
    'g',
  );
  return htmlContent.replace(externalLinkRegexp, '$1 target="_blank" rel="noopener noreferrer"$2');
};
